import React, { useState } from 'react';
import styles from '../dataProductDetailTab.module.scss';
import { DataProduct, User } from 'v2/models';
import SectionHeader from 'v2/common/DRM/SectionHeader/SectionHeader';
import classnames from 'classnames';
import { NoDataContent } from '../DataProductDetailTab';
import EditDatasetOwnerModal from '../../Modals/EditOwnerModal/EditDatasetOwnerModal';
import { TranslationKeys, PostProcessKeys } from 'translations';
import { useTranslation } from 'react-i18next';

type DatasetOwnerFieldProps = {
  hasValue: boolean;
  owner: User | undefined;
  dataset: DataProduct;
};

const DatasetOwnerField = ({
  hasValue,
  owner,
  dataset,
}: DatasetOwnerFieldProps) => {
  const { t } = useTranslation();
  const [showEditOwnerModal, setShowEditOwnerModal] = useState(false);

  return (
    <>
      <div className={styles.field} data-cy="dataset-owner-section">
        <SectionHeader
          title={`${t(TranslationKeys.dataProduct_one, {
            postProcess: PostProcessKeys.TitleCase,
          })} Owner`}
          isEditable={dataset.is_editable}
          className="mb-3"
          onClick={() => setShowEditOwnerModal(true)}
        />
        <NoDataContent title="the owner" hasValue={hasValue}>
          <div data-testid={`value_Owner`} className={styles.descriptionTexts}>
            <div>
              <div
                className={classnames(styles.ownerHeader)}
                data-cy="dataset-owner-full-name-text"
              >
                {owner?.first_name} {owner?.last_name}
              </div>
              <div className={classnames(styles.ownerDescription)}>
                {owner?.job_title && (
                  <p data-cy="dataset-owner-job-title-text">
                    {owner?.job_title}
                  </p>
                )}
                {owner?.email && (
                  <p>
                    <a
                      href={`mailto:${owner?.email}`}
                      data-cy="dataset-owner-email-link"
                    >
                      {owner?.email}
                    </a>
                  </p>
                )}
              </div>
            </div>
          </div>
        </NoDataContent>
      </div>

      <EditDatasetOwnerModal
        show={showEditOwnerModal}
        dataProduct={dataset}
        owner={owner}
        onClose={() => setShowEditOwnerModal(false)}
      />
    </>
  );
};

export default DatasetOwnerField;
